import {FileValidationResult} from "../types/telegram-chat-window.types";
import {ColumnPropertyLazySelect} from "../../../../core/types/records-table.types";

export const maxSizeBytes = 1073741824;

export const allowedTypes = {
  image: {
    mime: [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif',
      'image/webp'
    ],
    extensions: [
      'jpeg',
      'jpg',
      'png',
      'gif',
      'webp'
    ]
  },
  video: {
    mime: [
      'video/mp4',
      'video/webm',
      'video/quicktime',
      'video/x-msvideo',
      'video/x-matroska',
      'video/ogg'
    ],
    extensions: [
      'mp4',
      'webm',
      'mov',
      'avi',
      'mkv',
      'ogv'
    ]
  },
  document: {
    mime: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'text/plain',
      'text/csv',
      'application/rtf'
    ],
    extensions: [
      'pdf',
      'doc',
      'docx',
      'xls',
      'xlsx',
      'ppt',
      'pptx',
      'txt',
      'csv',
      'rtf'
    ]
  }
};

export const defaultFileValidationResult: FileValidationResult = {
  isValid: false,
  type: 'unknown'
}

export const propertyLazySelectRecordCalendarTgIds: ColumnPropertyLazySelect = {
  recourseName: 'MessageTelegramDto',
  providerType: 'RECORD_CALENDAR_IDS'
}

export const propertyLazySelectFileDestinations: ColumnPropertyLazySelect = {
  recourseName: 'TelegramSaveFileDestinationType',
  providerType: 'DEFAULT'
}
